import type { Mobility_Runs_Bool_Exp } from '@gql/base-types';

import { customerScopeFilter, windowFilter } from '@features/products/counts/countFilters';
import type { CountWindow } from '@features/products/counts/productCounts';

/** The column the Runs tab filters its window on, so the counts match the tab. */
export const MOBILESERVICE_WINDOW_COLUMN = 'departure_time';

export const buildMobileServiceCountsVariables = ({ customerIds, window }: { customerIds: number[]; window: CountWindow }) => ({
  scope: customerScopeFilter<Mobility_Runs_Bool_Exp>(customerIds),
  window: windowFilter<Mobility_Runs_Bool_Exp>(MOBILESERVICE_WINDOW_COLUMN, window),
});
